import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { FadeUp, Overline, GoldRule } from "../components/Reveal";
import { ArrowRight } from "lucide-react";

const ThankYou = () => (
  <div data-testid="thank-you-page">
    <SEO
      title="Thank You | Lunar Ambitions"
      description="Thank you for choosing Lunar Ambitions, licensed esthetician studio in Orlando, FL."
      robots="noindex, follow"
    />
    <section className="relative overflow-hidden bg-white pt-40 pb-32 min-h-[80vh] flex items-center">
      <div className="max-w-2xl mx-auto px-5 sm:px-8 w-full text-center">
        <FadeUp delay={0.05}>
          <Overline className="justify-center">
            Lunar Ambitions · Orlando, FL
          </Overline>
        </FadeUp>
        <FadeUp delay={0.15}>
          <h1
            className="mt-6 font-display font-normal tracking-tight leading-[1.05] text-navy text-4xl sm:text-5xl lg:text-6xl"
            data-testid="thank-you-heading"
          >
            Thank You
          </h1>
        </FadeUp>
        <FadeUp delay={0.3}>
          <GoldRule className="mt-10 w-24 mx-auto" />
          <p
            className="mt-8 text-base sm:text-lg text-navy/75 leading-relaxed font-light"
            data-testid="thank-you-message"
          >
            Your appointment is confirmed. Next, you will receive a confirmation
            email with further instructions and a form you need to fill out
            before your appointment. We look forward to seeing you.
          </p>
          <Link
            to="/"
            data-testid="thank-you-home-link"
            className="group mt-10 inline-flex items-center gap-3 bg-navy text-white text-sm tracking-[0.18em] uppercase font-medium px-9 py-4 transition-colors duration-300 hover:bg-gold hover:text-navy"
          >
            Back to Home
            <ArrowRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </Link>
        </FadeUp>
      </div>
    </section>
  </div>
);

export default ThankYou;
